import React from 'react';
import { KeyRound, Copy, X } from 'lucide-react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

/**
 * Toont het eenmalige wachtwoord van een versleutelde UWV-ZIP (AES-256).
 * Het wachtwoord wordt nergens opgeslagen: na sluiten is het weg.
 */
export const ZipWachtwoordDialoog: React.FC<{ wachtwoord: string; onSluit: () => void }> = ({ wachtwoord, onSluit }) => {
  const { t } = useTranslation('employer');
  const kopieer = async () => {
    try {
      await navigator.clipboard.writeText(wachtwoord);
      toast.success(t('zipWachtwoord.gekopieerd'));
    } catch {
      toast.error(t('zipWachtwoord.kopierenMislukt'));
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label={t('zipWachtwoord.ariaLabel')}>
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between px-5 py-3 border-b">
          <h3 className="font-semibold text-gray-900 flex items-center gap-2">
            <KeyRound className="w-4 h-4 text-blue-600" /> {t('zipWachtwoord.titel')}
          </h3>
          <button type="button" onClick={onSluit} className="text-gray-400 hover:text-gray-600" aria-label={t('zipWachtwoord.sluiten')}>
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="px-5 py-4 space-y-3 text-sm text-gray-700">
          <p>{t('zipWachtwoord.uitleg')}</p>
          <div className="flex items-center gap-2">
            <code className="flex-1 font-mono text-base tracking-wider bg-gray-50 border rounded px-3 py-2 select-all">{wachtwoord}</code>
            <button type="button" onClick={kopieer} className="p-2 rounded border hover:bg-gray-50" aria-label={t('zipWachtwoord.kopieerAria')}>
              <Copy className="w-4 h-4" />
            </button>
          </div>
          <ul className="list-disc pl-5 space-y-1 text-gray-600">
            <li>{t('zipWachtwoord.tipKanaal')}</li>
            <li>{t('zipWachtwoord.tipOpenen')}</li>
          </ul>
        </div>
        <div className="px-5 py-3 border-t flex justify-end">
          <button type="button" onClick={onSluit} className="px-4 py-2 rounded bg-blue-600 text-white hover:bg-blue-700">
            {t('zipWachtwoord.bewaard')}
          </button>
        </div>
      </div>
    </div>
  );
};
